module.exports = __webpack_public_path__ + "static/media/medocs_03_thumb_hover.f2544ae5.png";